import { initializeRpcUrls, getCurrentRpcUrl } from '@/helpers/constants'

let isInitialized = false

/**
 * Initialize RPC URLs by testing all available RPCs and caching working ones
 * This should be called once when the app starts
 */
export const initializeRpcSystem = async (): Promise<void> => {
  if (isInitialized) {
    return
  }

  try {
    await initializeRpcUrls()
    isInitialized = true
  } catch (error) {
    console.error('❌ Failed to initialize RPC system:', error)
    // Don't throw - app can still work with primary RPCs
  }
}

/**
 * Initialize RPC system synchronously (for immediate use)
 * This will use primary RPCs initially and update them asynchronously
 */
export const initializeRpcSystemSync = (): void => {
  if (isInitialized) {
    return
  }

  // Start the async initialization in the background
  initializeRpcSystem().catch(console.error)
}

/**
 * Get the current working RPC URL for a chain
 * Returns cached working URL or primary URL if not initialized
 */
export const getWorkingRpcForChain = (chainId: number): string => {
  return getCurrentRpcUrl(chainId as any)
}

/**
 * Check if RPC system has been initialized
 */
export const isRpcSystemInitialized = (): boolean => {
  return isInitialized
}

/**
 * Force refresh RPC URLs for all chains
 */
export const refreshAllRpcUrls = async (): Promise<void> => {
  await initializeRpcUrls()
}
